import styled from 'styled-components';

export const SideStrip = styled.div`
  width: 65px;
  padding-top: 60px;
  padding-bottom: 6px;
  position: fixed;
  left: 0px;
  top: 0px;
  bottom: 0px;
  background-color: ${({ theme }) => theme.palette.primary.dark};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  z-index: 12;
  box-shadow: 2px 0 6px 0 ${({ theme }) => theme.palette.grey['900']}24;

  .MuiDivider-root {
    width: calc(100% - 16px);
    border-color: ${(props) => props.theme.palette.divider}49;
  }
`;
